export const STEP2_SUBMIT_REQUEST = "STEP2_SUBMIT_REQUEST";
export const STEP2_SUBMIT_SUCCESS = "STEP2_SUBMIT_SUCCESS";
export const STEP2_SUBMIT_FAILED = "STEP2_SUBMIT_FAILED";

export const CLEAR_STEP2_FORM_SUCCESS = "CLEAR_STEP2_FORM_SUCCESS";
